export default state => state.vod.hodor.baseLink;
